import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { styled } from '@mui/material/styles';
export const SettingsGroupStyled = styled(ToggleButtonGroup)({
    marginTop: 2,
    marginBottom: 6,

    '& .MuiToggleButton-root': {
        paddingTop: 2,
        paddingBottom: 2,
        fontSize: '0.7rem',
        textTransform: 'none'
    }
});
